<div class="hedging-shell p-2 p-lg-2">
  <section class="hero-card">
    <div class="hero-copy">
      <div class="title-row">
        <h1>Profit Loss Report</h1>
      </div>
      <p>Review client-wise contract profitability with buyer and seller LOA mapping, commercial values, billed amount, and net profit.</p>
      <div class="hero-meta">
        <span class="hero-pill">{{ profitLossRows().length }} records</span>
        <span class="hero-pill">{{ selectedProfitLossMonthLabel() }} {{ selectedProfitLossYear() }}</span>
        <span class="hero-pill">All Clients</span>
      </div>
    </div>

    <div class="hero-actions">
      <label class="date-field">
        <span>Client Scope</span>
        <input class="form-control" type="text" value="All Clients" readonly />
      </label>
      <label class="date-field market-field">
        <span>Month</span>
        <select class="form-select" [ngModel]="selectedProfitLossMonth()" (ngModelChange)="setProfitLossMonth($event)">
          @for (option of profitLossMonthOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </label>
      <label class="date-field market-field">
        <span>Year</span>
        <select class="form-select" [ngModel]="selectedProfitLossYear()" (ngModelChange)="setProfitLossYear($event)">
          @for (year of profitLossYearOptions; track year) {
            <option [value]="year">{{ year }}</option>
          }
        </select>
      </label>
      <button type="button" class="toolbar-btn" (click)="exportProfitLossReport()">
        <lucide-icon [img]="FileTextIcon" [size]="15"></lucide-icon>
        <span>Export</span>
      </button>
    </div>
  </section>

  <section class="revision-card">
    <div class="revision-head">
      <div>
        <h2>Profit Loss Details</h2>
        <p>Client-wise buy and sell cost analysis with charges, billed amount, and net profit.</p>
      </div>
    </div>
    <div class="revision-table-wrap">
      <table class="revision-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Client Name</th>
            <th>Contract</th>
            <th>Buyer</th>
            <th>Seller</th>
            <th>Buyer LOA</th>
            <th>Seller LOA</th>
            <th>Buy Cost</th>
            <th>Sell Cost</th>
            <th>Charges</th>
            <th>Total Revenue</th>
            <th>Billed</th>
          </tr>
        </thead>
        <tbody>
          @if (profitLossLoading()) {
            <tr><td colspan="12" class="empty-state">Wait for the profit-loss records.</td></tr>
          } @else if (profitLossRows().length === 0) {
            <tr><td colspan="12" class="empty-state">No profit-loss records found for the selected client and period.</td></tr>
          } @else {
            @for (row of profitLossRows(); track row.contractNumber + row.clientName + row.serialNo) {
              <tr>
                <td>{{ row.serialNo }}</td>
                <td>{{ row.clientName }}</td>
                <td>{{ row.contractNumber }}</td>
                <td>{{ row.buyer }}</td>
                <td>{{ row.seller }}</td>
                <td>{{ row.buyerLoa }}</td>
                <td>{{ row.sellerLoa }}</td>
                <td [class.text-orange]="row.buyCost <= 0">
                  <button type="button" class="calc-value-btn" (click)="openCostCalculationModal(row, 'buy')">{{ row.buyCost > 0 ? formatRupees(row.buyCost) : 'Rate not available' }}</button>
                </td>
                <td [class.text-orange]="row.sellCost <= 0">
                  <button type="button" class="calc-value-btn" (click)="openCostCalculationModal(row, 'sell')">{{ row.sellCost > 0 ? formatRupees(row.sellCost) : 'Rate not available' }}</button>
                </td>
                <td>
                  <button type="button" class="calc-value-btn" (click)="openChargeCalculationModal(row)">{{ formatRupees(row.charges) }}</button>
                </td>
                <td>{{ formatSignedRupees(row.totalRevenue) }}</td>
                <td>{{ formatSignedRupees(row.billed) }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </section>
</div>

@if (calculationModal(); as modal) {
  <div class="calc-modal-backdrop" (click)="closeCalculationModal()">
    <div class="calc-modal-card" role="dialog" aria-modal="true" aria-label="Cost calculation" (click)="$event.stopPropagation()">
      <div class="calc-modal-head">
        <div>
          <div class="calc-modal-eyebrow">Cost Calculation</div>
          <h2>{{ modal.title }}</h2>
          <p>{{ modal.subtitle }}</p>
        </div>
        <button type="button" class="close-btn" (click)="closeCalculationModal()" aria-label="Close calculation modal">
          <lucide-icon [img]="CloseIcon" [size]="16"></lucide-icon>
        </button>
      </div>
      <div class="calc-modal-body">
        <div class="calc-equation">{{ modal.equation }}</div>
        <p class="calc-modal-hint">{{ modal.hint }}</p>
        <div class="calc-detail-list">
          @for (detail of modal.details; track detail.label) {
            <div class="calc-detail-row">
              <span>{{ detail.label }}</span>
              <strong>{{ detail.value }}</strong>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
